import { memo } from 'react'
import ListQueryToolbar from '../shared/ListQueryToolbar'
import { PRODUCT_SEARCH_DEBOUNCE_MS } from '../../utils/productManagementUtils'

function ProductSearchBar({
  appliedSearch = '',
  onApplySearchQuery,
  onClearFilters,
  isDefault = true,
  recent = [],
  onApplyRecent,
}) {
  return (
    <ListQueryToolbar
      label="Search by Article Code"
      placeholder="Enter Article Code to search products..."
      debounceMs={PRODUCT_SEARCH_DEBOUNCE_MS}
      appliedSearch={appliedSearch}
      onApplySearchQuery={onApplySearchQuery}
      onClearFilters={onClearFilters}
      isDefault={isDefault}
      recent={recent}
      onApplyRecent={onApplyRecent}
    />
  )
}

export default memo(ProductSearchBar)
